import { render } from "./CouponSvg.vue?vue&type=template&id=508f7716&ts=true"
import script from "./CouponSvg.vue?vue&type=script&lang=ts"
export * from "./CouponSvg.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__